import { useState } from 'react';
import { Heart } from 'lucide-react';
import { appConfig } from '@/config';
import { Button } from '@/components/ui';
import { DonationModal } from './DonationModal';

export function DonationBanner() {
  const [modalOpen, setModalOpen] = useState(false);

  if (!appConfig.donation.enabled) {
    return null;
  }

  return (
    <>
      <div
        role="region"
        aria-label="Convite de apoio voluntário"
        className="sticky top-[var(--header-height)] z-20 border-b border-[var(--primary)]/20 bg-[var(--primary)]/10 px-4 py-3 backdrop-blur-sm md:px-6"
      >
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
          <div className="flex min-w-0 items-start gap-3 sm:flex-1">
            <Heart
              size={18}
              className="mt-0.5 shrink-0 text-[var(--primary)] sm:mt-0"
              aria-hidden
            />
            <p className="min-w-0 flex-1 text-sm leading-relaxed text-[var(--foreground)]">
              <span className="font-medium">De Irmão para Irmãos.</span>{' '}
              {appConfig.donation.message}
            </p>
          </div>
          <Button
            className="w-full shrink-0 sm:w-auto"
            onClick={() => setModalOpen(true)}
          >
            Apoiar este trabalho
            <Heart size={16} aria-hidden />
          </Button>
        </div>
      </div>

      <DonationModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}
